export default __webpack_public_path__ + "static/image-a-0c08ceeace2380f1049d3fb899750b2f.webp";